import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select, Modal, Form } from 'antd';
import { useNavigate, useSearchParams } from "react-router";
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import UserService from 'services/user';
import { useApp } from "contexts/app";
import _ from "lodash"
const { Search } = Input;
const service = new UserService();


const UserList = () => {
    let navigate = useNavigate();
    const [data, setData] = useState([]);
    const { showNotify, modal, showLoading, prompt } = useApp();
    const [filter, setFilter] = useState({})

    const [showAddUser, setShowAddUser] = useState(false)


    useEffect(() => {
        delaySearch(filter);


    }, [filter])

    const onSearch = async (data) => {
        var postData = { info: data?.info };
        var list = await service.getInviteList(postData);
        setData(list);
    }


    const delaySearch = useMemo(() => _.debounce(onSearch, 500, { leading: false }), []);


    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }

    const loadData = async () => {
        var list = await service.getInviteList();
        setData(list);
    }


    const cancelInvite = async (id) => {
        showLoading(true);
        await service.cancelInvite(id);
        showNotify("Đã từ chối");
        await loadData();
        showLoading(false)
    }



    const acceptInvite = async (id) => {
        showLoading(true);
        await service.acceptInvite(id);
        showNotify("Đã chấp nhật lời mời");
        await loadData();
        showLoading(false)
    }







    const columns = [
        {
            title: 'Shop ',
            render: (_, record) => {
                return (
                    <div>
                        <Space>

                            <div>
                                {record.work_space.name} đã mời bạn tham gia
                            </div>
                        </Space>
                    </div>

                )
            }
        },


        {
            title: "",
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type='link' onClick={e => acceptInvite(record.id)}>Chấp nhận</Button>
                    <Button type='link' onClick={e => cancelInvite(record.id)}>Từ chối</Button>
                </Space>
            ),
        },
    ];



    return (

        <Space direction="vertical" size={16} style={{ width: "100%" }}>

            <Card>
                <Table columns={columns} dataSource={data} />
            </Card>

        </Space>
    )
}





export default UserList;